import { createSlice } from "@reduxjs/toolkit";

export const QcastSlice = createSlice({
  name: "qcast",
  initialState: { currentQcast: {}, currentResponse: {} },
  reducers: {
    currentQcast: (state, action) => {
      const { payload } = action;

      return { ...state, currentQcast: { ...state.currentQcast, ...payload } };
    },
    currentResponse: (state, action) => {
      const { payload } = action;
      state.currentResponse = payload;
    },
  },
});

export default QcastSlice.reducer;
